export default (initialState = null) => ({
    rooms: [
        {
            adults: 2,
            children: 0,
            ages: []
        }
    ],
    add(){
        this.rooms.push({
            adults: 2,
            children: 0,
            ages: []
        })
    },
    remove(ind){
      this.rooms.splice(ind, 1)
    },
    init(){
        //console.log(initialState)
        if(initialState){
            this.rooms = initialState;
        }
    }
})